module.exports = __webpack_public_path__ + "static/mark-brown-ee897836205428ac1f9661de45d6f560.png";